import React from "react";
import { Grid } from "@mui/material";

const { innerHeight } = window;

export default function AppSubContainer({ children }) {
    return (
        <Grid item xs={12}>
            <div className="innerMainbox" style={{ height: innerHeight * 0.9 }}>
                {children}
            </div>
        </Grid>
    );
}
